// add event name. and group event name by feature.
// you need to event name by `import { slEvents } from '../utils/slEventBus';`
// slEvents.promotion.GROUP_NAME.EVENT_NAME
// i.e: feature with service structure
// promotion: { xxxxx }
const eventMetaMap = {
  general: {
    currencyChanged: {
      name: 'general.currencyChanged',
    },
  },
  cart: {
    miniCartLoadData: {
      name: 'cart.miniCartLoadData',
    },
    itemAdded: {
      name: 'cart.itemAdded',
    },
    itemUpdated: {
      name: 'cart.itemUpdated',
    },
    itemRemoved: {
      name: 'cart.itemRemoved',
    },
  },
};

export default eventMetaMap;
